window.app.factory("printElement", [
  function() {
    return function printElement(elSpec) {
      const el =
        typeof elSpec === "string" ? document.querySelector(elSpec) : elSpec;
      const printWrapper = document.createElement("div");
      printWrapper.className = "__print_clone__";
      printWrapper.style.position = "absolute";
      printWrapper.style.top = "0";
      printWrapper.style.width = "100%";
      printWrapper.appendChild(el.cloneNode(true));
      document.body.appendChild(printWrapper);
      window.print();
      printWrapper.remove();
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/printElement.js